import * as Components from './components';
import config from './config';

export const ROUTE_AI_OUTREACH_AGENTS_NEW = 'AI_OUTREACH_AGENTS_NEW';
export const ROUTE_AI_OUTREACH_AGENTS_LIST = 'AI_OUTREACH_AGENTS_LIST';
export const ROUTE_CLIENTS_LIST = 'ADMINISTRATION_CLIENT_LIST';
export const ROUTE_CLIENTS_NEW = 'ADMINISTRATION_CLIENT_NEW';
export const ROUTE_CLIENT_PACKAGES_LIST = 'ADMINISTRATION_CLIENT_PACKAGE_LIST';
export const ROUTE_CLIENT_PACKAGES_NEW = 'ADMINISTRATION_CLIENT_PACKAGE_NEW';

export const ROUTE_PAGE_GROUPS_NEW = 'PAGE_GROUPS_NEW';
export const ROUTE_PAGE_GROUPS_LIST = 'PAGE_GROUPS_LIST';
export const ROUTE_COUNTRY_REGIONS_NEW = 'COUNTRY_REGIONS_NEW';
export const ROUTE_COUNTRY_REGIONS = 'COUNTRY_REGIONS';
export const ROUTE_LEAD_VISITS = 'LEAD_VISITS_LIST';
export const ROUTE_LEAD_VISIT_DETAILS = 'LEAD_VISIT_DETAILS';
export const ROUTE_CAMPAIGNS_LIST = 'CAMPAIGNS_LIST';
export const ROUTE_CAMPAIGNS_NEW = 'CAMPAIGNS_NEW';

const Routes = {
  LOGIN: {
    path: '/login/',
    models: () => [
      import('./models/login'),
      import('./models/header'),
    ],
    component: () => import('./routes/login'),
  },
  LOGOUT: {
    path: '/logout/',
    component: () => import('./routes/login'),
  },
  FIRST_LOGIN: {
    path: `${config['app.frontend_change_password_url'].substr(2)}/`,
    component: () => import('./routes/firstLogin'),
  },
  FORGOT_PASSWORD: {
    path: '/forgot-password/',
    component: () => import('./routes/forgotPassword'),
  },
  RECOVER_PASSWORD: {
    path: `${config['app.frontend_forget_password_url'].substr(2)}/`,
    component: () => import('./routes/firstLogin'),
  },
  PROFILE: {
    path: '/profile/',
    models: () => [
      import('./models/users'),
      import('./models/header'),
    ],
    component: () => Components.Profile,
  },
  USERS_LIST: {
    path: '/users/',
    models: () => [
      import('./models/users'),
      import('./models/header'),
    ],
    component: () => Components.UsersAdministration,
  },
  USER_NEW: {
    path: '/users/new/',
    models: () => [
      import('./models/users'),
      import('./models/header'),
    ],
    component: () => Components.UserItem,
    parent: 'USERS_LIST',
  },
  USER_NEW_SUPERADMIN: {
    path: '/users/new-superadmin/',
    models: () => [
      import('./models/users'),
      import('./models/header'),
    ],
    component: () => Components.UsersNewSuperadmin,
    parent: 'USERS_LIST',
  },
  USER_EDIT: {
    path: '/users/:userId/edit/',
    models: () => [
      import('./models/users'),
      import('./models/header'),
    ],
    component: () => Components.UserItem,
    parent: 'USERS_LIST',
  },
  LEAD_SCORING_LIST: {
    path: '/:projectId/lead-scoring/',
    models: () => [
      import('./models/leadScoring'),
      import('./models/header'),
      import('./models/hubspotOwners'),
    ],
    component: () => Components.LeadScoringList,
  },
  LEAD_SCORING_EDIT: {
    path: '/:projectId/lead-scoring/:leadScoringId/edit/',
    models: () => [
      import('./models/leadScoring'),
      import('./models/header'),
      import('./models/countries'),
      import('./models/branches'),
      import('./models/companies'),
      import('./models/pageGroups'),
      import('./models/leadLabels'),
      import('./models/countryRegions'),
      import('./models/campaigns'),
      import('./models/hubspotOwners'),
      import('./models/hubspot'),
    ],
    component: () => Components.LeadScoringItem,
    parent: 'LEAD_SCORING_LIST',
  },
  LEAD_SCORING_NEW: {
    path: '/:projectId/lead-scoring/new/:copyProjectId?',
    models: () => [
      import('./models/leadScoring'),
      import('./models/header'),
      import('./models/countries'),
      import('./models/branches'),
      import('./models/companies'),
      import('./models/pageGroups'),
      import('./models/leadLabels'),
      import('./models/countryRegions'),
      import('./models/campaigns'),
      import('./models/hubspotOwners'),
      import('./models/hubspot'),
      import('./models/projects'),
    ],
    component: () => Components.LeadScoringItem,
    parent: 'LEAD_SCORING_LIST',
  },
  CATEGORIES_LIST: {
    path: '/categories/',
    models: () => [
      import('./models/categories'),
      import('./models/header'),
    ],
    component: () => Components.CategoriesList,
  },
  CATEGORY_EDIT: {
    path: '/categories/:categoryId/edit/',
    models: () => [
      import('./models/categories'),
      import('./models/header'),
    ],
    component: () => Components.CategoryItem,
    parent: 'CATEGORIES_LIST',
  },
  CATEGORY_NEW: {
    path: '/categories/new/',
    models: () => [
      import('./models/categories'),
      import('./models/header'),
    ],
    component: () => Components.CategoryItem,
    parent: 'CATEGORIES_LIST',
  },
  COMPANIES_LIST: {
    path: '/:projectId/companies/overview/',
    models: () => [
      import('./models/companies'),
      import('./models/header'),
      import('./models/leads'),
    ],
    component: () => Components.CompaniesList,
  },
  COMPANY_EDIT: {
    path: '/:projectId/company/:companyId/edit/',
    models: () => [
      import('./models/companies'),
      import('./models/header'),
      import('./models/leadLabels'),
    ],
    component: () => Components.CompanyItem,
    parent: 'COMPANIES_LIST',
  },
  COMPANY_NEW: {
    path: '/:projectId/company/new/',
    models: () => [
      import('./models/companies'),
      import('./models/header'),
      import('./models/leadLabels'),
    ],
    component: () => Components.CompanyItem,
    parent: 'COMPANIES_LIST',
  },
  CAMPAIGNS_LIST: {
    path: '/projects/:projectId/campaigns/',
    models: () => [
      import('./models/header'),
      import('./models/campaigns'),
    ],
    component: () => Components.CampaignsList,
  },
  CAMPAIGNS_EDIT: {
    path: '/projects/:projectId/campaigns/:campaignId/edit/',
    models: () => [
      import('./models/header'),
      import('./models/campaigns'),
    ],
    component: () => Components.CampaignsItem,
    parent: 'CAMPAIGNS_LIST',
  },
  CAMPAIGNS_NEW: {
    path: '/projects/:projectId/campaigns/new/',
    models: () => [
      import('./models/header'),
      import('./models/campaigns'),
    ],
    component: () => Components.CampaignsItem,
    parent: 'CAMPAIGNS_LIST',
  },
  TARGET_GROUP_NEW: {
    path: '/:projectId/target-groups/new/',
    models: () => [
      import('./models/targetGroups'),
      import('./models/categories'),
      import('./models/countries'),
      import('./models/branches'),
      import('./models/companies'),
      import('./models/leadLabels'),
      import('./models/header'),
      import('./models/countryRegions'),
      import('./models/campaigns'),
    ],
    component: () => Components.TargetGroupItem,
    parent: 'TARGET_GROUPS_LIST',
  },
  TARGET_GROUP_EDIT: {
    path: '/:projectId/target-groups/:id/edit/',
    models: () => [
      import('./models/targetGroups'),
      import('./models/categories'),
      import('./models/countries'),
      import('./models/branches'),
      import('./models/companies'),
      import('./models/leadLabels'),
      import('./models/header'),
      import('./models/countryRegions'),
      import('./models/campaigns'),
    ],
    component: () => Components.TargetGroupItem,
    parent: 'TARGET_GROUPS_LIST',
  },
  TARGET_GROUPS_LIST: {
    path: '/:projectId/target-groups/',
    models: () => [
      import('./models/targetGroups'),
      import('./models/categories'),
      import('./models/header'),
    ],
    component: () => Components.TargetGroupsList,
  },
  LEAD_LABELS_LIST: {
    path: '/lead-labels/',
    models: () => [
      import('./models/leadLabels'),
      import('./models/header'),
    ],
    component: () => Components.LeadLabelsList,
  },
  LEAD_LABEL_NEW: {
    path: '/lead-labels/new/',
    models: () => [
      import('./models/leadLabels'),
      import('./models/header'),
    ],
    component: () => Components.LeadLabelsItem,
    parent: 'LEAD_LABELS_LIST',
  },
  LEAD_LABEL_EDIT: {
    path: '/lead-labels/:id/edit/',
    models: () => [
      import('./models/leadLabels'),
      import('./models/header'),
    ],
    component: () => Components.LeadLabelsItem,
    parent: 'LEAD_LABELS_LIST',
  },
  BRANCH_NEW: {
    path: '/branches/new/',
    models: () => [
      import('./models/branches'),
      import('./models/header'),
    ],
    component: () => Components.BranchItem,
    parent: 'BRANCHES_LIST',
  },
  BRANCHES_LIST: {
    path: '/branches/',
    models: () => [
      import('./models/branches'),
      import('./models/targetGroups'),
      import('./models/header'),
    ],
    component: () => Components.BranchesList,
  },
  BRANCH_EDIT: {
    path: '/branches/:id/edit/',
    models: () => [
      import('./models/branches'),
      import('./models/targetGroups'),
      import('./models/header'),
    ],
    component: () => Components.BranchItem,
    parent: 'BRANCHES_LIST',
  },
  AI_OUTREACH_AGENTS_LIST: {
    path: '/:projectId/ai-outreach-agents/',
    models: () => [
      import('./models/aiOutreachAgents'),
      import('./models/header'),
      import('./models/leadContact'),
    ],
    component: () => Components.AIOutreachAgentsList,
  },
  AI_OUTREACH_AGENTS_NEW: {
    path: '/:projectId/ai-outreach-agents/new/:copyAIOutreachAgentId?',
    models: () => [
      import('./models/aiOutreachAgents'),
      import('./models/header'),
    ],
    component: () => Components.AIOutreachAgentsItem,
    parent: 'AI_OUTREACH_AGENTS_LIST',
  },
  AI_OUTREACH_AGENT_EDIT: {
    path: '/:projectId/ai-outreach-agents/:aiOutreachAgentId/edit/',
    models: () => [
      import('./models/aiOutreachAgents'),
      import('./models/header'),
    ],
    component: () => Components.AIOutreachAgentsItem,
    parent: 'AI_OUTREACH_AGENTS_LIST',
  },
  ACCOUNTS_LIST: {
    path: '/account-settings/',
    models: () => [
      import('./models/projects'),
      import('./models/header'),
    ],
    component: () => Components.ProjectsList,
  },
  ACCOUNT_EDIT: {
    path: '/account-settings/:id/edit/',
    models: () => [
      import('./models/projects'),
      import('./models/users'),
      import('./models/matomo'),
      import('./models/header'),
      import('./models/hubspotOwners'),
      import('./models/hubspot'),
    ],
    component: () => Components.ProjectItem,
    parent: 'ACCOUNTS_LIST',
  },
  ACCOUNT_NEW: {
    path: '/account-settings/new/',
    models: () => [
      import('./models/projects'),
      import('./models/users'),
      import('./models/matomo'),
      import('./models/header'),
      import('./models/hubspotOwners'),
      import('./models/hubspot'),
    ],
    component: () => Components.ProjectItem,
    parent: 'ACCOUNTS_LIST',
  },
  LEAD_COMPANIES_LIST: {
    path: '/:projectId/lead-management/companies/',
    models: () => [
      import('./models/leads'),
      import('./models/companies'),
      import('./models/countries'),
      import('./models/leadLabels'),
      import('./models/branches'),
      import('./models/header'),
      import('./models/matomo'),
      import('./models/hubspot'),
      import('./models/hubspotOwners'),
      import('./models/aiOutreachAgents'),
      import('./models/leadContact'),
    ],
    component: () => Components.LeadsCompaniesOverview,
  },
  LEAD_VISITS_LIST: {
    path: '/:projectId/lead-management/visits/',
    models: () => [
      import('./models/leads'),
      import('./models/leadLabels'),
      import('./models/branches'),
      import('./models/header'),
      import('./models/matomo'),
      import('./models/countries'),
      import('./models/hubspot'),
      import('./models/hubspotOwners'),
      import('./models/aiOutreachAgents'),
      import('./models/leadContact'),
    ],
    component: () => Components.LeadsVisitsOverview,
  },
  LEAD_VISIT_DETAILS: {
    path: '/:projectId/lead-management/leads/:leadId/details/',
    models: () => [
      import('./models/projects'),
      import('./models/matomo'),
      import('./models/leads'),
      import('./models/leadLabels'),
      import('./models/header'),
    ],
    component: () => Components.LeadDetails,
    parent: 'LEAD_VISITS_LIST',
  },
  LEAD_VISITS_ALL: {
    path: '/:projectId/lead-management/leads/:leadId/all-visits/',
    models: () => [
      import('./models/matomo'),
      import('./models/leads'),
      import('./models/header'),
    ],
    component: () => Components.LeadVisitsAll,
    parent: 'LEAD_VISITS_LIST',
  },
  LEAD_VISITS_VISIT_DETAILS: {
    path: '/:projectId/companies/:companyId/visits/:visitId',
    models: () => [
      import('./models/matomo'),
      import('./models/leads'),
      import('./models/header'),
    ],
    component: () => Components.LeadVisitDetails,
    parent: 'LEAD_VISITS_LIST',
  },
  LEAD_VISIT_PAGE_DETAILS: {
    path: '/:projectId/companies/:companyId/visits/:visitId/pages/:page',
    models: () => [
      import('./models/matomo'),
      import('./models/leads'),
      import('./models/header'),
    ],
    component: () => Components.LeadPageDetails,
    parent: 'LEAD_VISITS_LIST',
  },
  PAGE_GROUPS_LIST: {
    path: '/:projectId/page-groups/',
    models: () => [
      import('./models/pageGroups'),
      import('./models/header'),
    ],
    component: () => Components.PageGroupsList,
  },
  PAGE_GROUPS_NEW: {
    path: '/:projectId/page-groups/new/:copyPageGroupId?',
    models: () => [
      import('./models/pageGroups'),
      import('./models/header'),
    ],
    component: () => Components.PageGroupsItem,
    parent: 'PAGE_GROUPS_LIST',
  },
  PAGE_GROUPS_EDIT: {
    path: '/:projectId/page-groups/:pageGroupId/edit/',
    models: () => [
      import('./models/pageGroups'),
      import('./models/header'),
    ],
    component: () => Components.PageGroupsItem,
    parent: 'PAGE_GROUPS_LIST',
  },
  COUNTRY_REGIONS: {
    path: '/county-regions/',
    models: () => [
      import('./models/countryRegions'),
      import('./models/header'),
    ],
    component: () => Components.CountryRegionsList,
  },
  COUNTRY_REGIONS_NEW: {
    path: '/county-regions/new',
    models: () => [
      import('./models/countryRegions'),
      import('./models/header'),
      import('./models/countries'),
    ],
    component: () => Components.CountryRegionsItem,
    parent: 'COUNTRY_REGIONS',
  },
  COUNTRY_REGIONS_EDIT: {
    path: '/county-regions/:countryRegionId/edit/',
    models: () => [
      import('./models/countryRegions'),
      import('./models/header'),
      import('./models/countries'),
    ],
    component: () => Components.CountryRegionsItem,
    parent: 'COUNTRY_REGIONS',
  },
  ADMINISTRATION_CLIENT_LIST: {
    path: '/administration/clients/',
    models: () => [
      import('./models/header'),
      import('./models/clients'),
      import('./models/clientPackages'),
    ],
    component: () => Components.ClientsList,
  },
  ADMINISTRATION_CLIENT_NEW: {
    path: '/administration/clients/new/',
    models: () => [
      import('./models/clients'),
      import('./models/clientPackages'),
      import('./models/header'),
    ],
    component: () => Components.ClientsItem,
    parent: 'ADMINISTRATION_CLIENT_LIST',
  },
  ADMINISTRATION_CLIENT_EDIT: {
    path: '/administration/clients/:clientId/edit/',
    models: () => [
      import('./models/clients'),
      import('./models/clientPackages'),
      import('./models/header'),
    ],
    component: () => Components.ClientsItem,
    parent: 'ADMINISTRATION_CLIENT_LIST',
  },
  ADMINISTRATION_CLIENT_PACKAGE_LIST: {
    path: '/administration/client-packages/',
    models: () => [
      import('./models/header'),
      import('./models/clientPackages'),
    ],
    component: () => Components.ClientPackagesList,
  },
  ADMINISTRATION_CLIENT_PACKAGE_NEW: {
    path: '/administration/client-packages/new/',
    models: () => [
      import('./models/clientPackages'),
      import('./models/header'),
    ],
    component: () => Components.ClientPackagesItem,
    parent: 'ADMINISTRATION_CLIENT_PACKAGE_LIST',
  },
  ADMINISTRATION_CLIENT_PACKAGE_EDIT: {
    path: '/administration/client-packages/:clientPackageId/edit/',
    models: () => [
      import('./models/clientPackages'),
      import('./models/header'),
    ],
    component: () => Components.ClientPackagesItem,
    parent: 'ADMINISTRATION_CLIENT_PACKAGE_LIST',
  },
  ADMINISTRATION_USER_LIST: {
    path: '/administration/users/',
    models: () => [
      import('./models/users'),
      import('./models/header'),
    ],
    component: () => Components.UsersAdministration,
  },
  ADMINISTRATION_USER_NEW: {
    path: '/administration/users/new/',
    models: () => [
      import('./models/users'),
      import('./models/header'),
    ],
    component: () => Components.UserItem,
    parent: 'ADMINISTRATION_USER_LIST',
  },
  ADMINISTRATION_USER_EDIT: {
    path: '/administration/users/:userId/edit/',
    models: () => [
      import('./models/users'),
      import('./models/header'),
    ],
    component: () => Components.UserItem,
    parent: 'ADMINISTRATION_USER_LIST',
  },
};

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js